import styled from "styled-components";

import { FlexGap } from "components";

export const StyledDescription = styled(FlexGap)`
  padding-bottom: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral300};
`;
